import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María L.',
  quote: 'Desde que apliqué el semáforo, dejé de estar nerviosa cada vez que me llegaba un mensaje. Mis hijos me ven más tranquila y volvimos a disfrutar los fines de semana.'
}, {
  name: 'Carlos R.',
  quote: 'Pensé que tenía que ceder en todo para evitar peleas. Este manual me enseñó a poner límites sin generar una guerra. Mi salud mental dio un giro de 180 grados.'
}, {
  name: 'Luciana P.',
  quote: 'El método BIFF es magia pura. Mi ex dejó de mandarme testamentos porque ya no le doy el combustible que buscaba. Literalmente me ayudo mucho.'
}];
export function Testimonials() {
  return <section className="bg-[#17304F] py-24 px-6" data-id="element-303">
      <div className="max-w-5xl mx-auto" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-305">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-306">
            Lo que dicen quienes ya recuperaron su paz
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-307">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col" data-id="element-308">
              <div className="flex gap-1 mb-6" data-id="element-309">
                {[...Array(5)].map((_, index) => <Star key={index} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-310" />)}
              </div>
              <p className="text-slate-700 text-lg italic mb-6 flex-grow leading-relaxed" data-id="element-311">
                "{t.quote}"
              </p>
              <p className="font-bold text-navy" data-id="element-312">{t.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}